import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          title="关于合集、字幕与更新的常见疑问"
          description="在片荒挑片之前，先看看这几个大家最常问到的问题，能省下不少来回确认的时间。"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? "border-primary-200" : "border-background-200"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer md:px-5"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i
                        className={open ? "ri-subtract-line" : "ri-add-line"}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                </h3>
                {open ? (
                  <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-700 md:px-5">
                    {item.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}